module.exports = __webpack_public_path__ + "static/media/green_office.bfed4053.jpg";